import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Divider } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    color: "#FFF",
    padding: "0 0 0 10px",
    // borderRight: "1px solid #F2F2F2",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "0 0 0 10px",
  },
}));

const rowTexts = ["item1"];

function createData(
  item1,
  item2,
  item3,
  item4,
  item5,
  item6,
  item7,
  item8,
  item9,
  item10,
  item11,
  item12
) {
  return {
    item1,
    item2,
    item3,
    item4,
    item5,
    item6,
    item7,
    item8,
    item9,
    item10,
    item11,
    item12,
  };
}

const rows = [
  createData(
    "25648",
    "A48958",
    "00XXBD56XDE",
    "T08",
    "Salman",
    "Karim",
    "Rasturant",
    "Running",
    "22:54",
    "10-Jan-22",
    "Sale",
    "3:30PM - 4:30PM"
  ),
  createData(
    "25648",
    "A48958",
    "00XXBD56XDE",
    "T08",
    "Salman",
    "Karim",
    "Rasturant",
    "Running",
    "22:54",
    "10-Jan-22",
    "Sale",
    "3:30PM - 4:30PM"
  ),
  createData(
    "25648",
    "A48958",
    "00XXBD56XDE",
    "T08",
    "Salman",
    "Karim",
    "Rasturant",
    "Running",
    "22:54",
    "10-Jan-22",
    "Sale",
    "3:30PM - 4:30PM"
  ),
  createData(
    "25648",
    "A48958",
    "00XXBD56XDE",
    "T08",
    "Salman",
    "Karim",
    "Rasturant",
    "Running",
    "22:54",
    "10-Jan-22",
    "Sale",
    "3:30PM - 4:30PM"
  ),
];

const headTexts = [
  "Number",
  "Ticket Token",
  "Gov. Invoice No",
  "Table",
  "Waiter",
  "Customer",
  "Department",
  "Status",
  "Duration",
  "Date",
  "Sattle By",
  "Open-Close",
];

export default function DataTable() {
  return (
    <TableContainer>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow sx={{ height: 44 }}>
            {headTexts.map((text, idx) => (
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#37465B" : "#5D687A"}` }}
              >
                {text}
              </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx) => (
            <TableRow
              key={row.item1}
              sx={{
                "&:last-child td, &:last-child th": { border: 0 },
                height: 30,
              }}
            >
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#D9E9FF" : "#B8D2FF"}` }}
              >
                {row.item1}
              </StyledTableCell>

              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#EBF2FF" : "#D9E6FF"}` }}
              >
                {row.item2}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#D9E9FF" : "#B8D2FF"}` }}
              >
                {row.item3}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#EBF2FF" : "#D9E6FF"}` }}
              >
                {row.item4}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#D9E9FF" : "#B8D2FF"}` }}
              >
                {row.item5}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#EBF2FF" : "#D9E6FF"}` }}
              >
                {row.item6}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#D9E9FF" : "#B8D2FF"}` }}
              >
                {row.item7}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#EBF2FF" : "#D9E6FF"}` }}
              >
                {row.item8}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#D9E9FF" : "#B8D2FF"}` }}
              >
                {row.item9}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#EBF2FF" : "#D9E6FF"}` }}
              >
                {row.item10}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#D9E9FF" : "#B8D2FF"}` }}
              >
                {row.item11}
              </StyledTableCell>
              <StyledTableCell
                align="left"
                sx={{ background: `${idx % 2 == 0 ? "#EBF2FF" : "#D9E6FF"}` }}
              >
                {row.item12}
              </StyledTableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
